import { styled } from '@mui/material/styles'

export const Tax = styled('span', {
  name: 'Tax',
  slot: 'Root',
  skipSx: true,
})`
  font-family: 'Source Sans Pro';
  margin-right: 12px;
`
